import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Sessão do portal do colaborador CLT — o terceiro mundo de autenticação.
 *
 * O campo é `accessToken` em TODO lugar: aqui, no interceptor do `employeeApi`,
 * no `EmployeeRoute` e nos redirects do `App.tsx`. Isso é deliberado — o
 * `freelancerAuthSlice` grava `token` enquanto três pontos de redirecionamento
 * leem `accessToken`, e por isso a sessão de freelancer nunca é reconhecida
 * neles (BUG-006). Aqui não há dois nomes para a mesma coisa.
 *
 * A persistência é só pelo redux-persist (`whitelist` em `store.ts`). Nada de
 * `localStorage` manual: dois lugares guardando a mesma sessão é como o bug de
 * cima nasceu.
 */
type EmployeeAuthState = {
  accessToken: string | null;
  tokenType: "Bearer" | null;
  expiresIn: string | null;
  /** Enquanto verdadeiro, o portal só libera a tela de primeiro acesso. */
  isFirstLogin: boolean;
  /** Nome para o cabeçalho. O token não carrega PII — este valor vem do login. */
  fullName: string | null;
};

const initialState: EmployeeAuthState = {
  accessToken: null,
  tokenType: null,
  expiresIn: null,
  isFirstLogin: false,
  fullName: null,
};

export const employeeAuthSlice = createSlice({
  name: "employeeAuth",
  initialState,
  reducers: {
    setEmployeeSession: (
      state,
      action: PayloadAction<{
        accessToken: string;
        tokenType: "Bearer";
        expiresIn: string;
        isFirstLogin: boolean;
        fullName: string;
      }>
    ) => {
      state.accessToken = action.payload.accessToken;
      state.tokenType = action.payload.tokenType;
      state.expiresIn = action.payload.expiresIn;
      state.isFirstLogin = action.payload.isFirstLogin;
      state.fullName = action.payload.fullName;
    },
    clearEmployeeSession: (state) => {
      state.accessToken = null;
      state.tokenType = null;
      state.expiresIn = null;
      state.isFirstLogin = false;
      state.fullName = null;
    },
  },
});

export const { setEmployeeSession, clearEmployeeSession } = employeeAuthSlice.actions;
export default employeeAuthSlice.reducer;
